module.exports = __webpack_public_path__ + "static/media/banner-1-my.d0ab71de.jpg";